import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1f12f8fe"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "attendanceAnalysis"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "num"
};
var _hoisted_4 = {
  class: "desc"
};
var _hoisted_5 = {
  class: "box"
};
var _hoisted_6 = {
  class: "w-100"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th", null, "部门"), /*#__PURE__*/_createElementVNode("th", null, "应出勤人数"), /*#__PURE__*/_createElementVNode("th", null, "未出勤人数"), /*#__PURE__*/_createElementVNode("th", null, "出勤率")], -1);
});
var _hoisted_8 = {
  class: "title flex align-center justify-between mt-2"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "各部门月度分析", -1);
});
var _hoisted_10 = {
  class: "box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_title = _resolveComponent("c-title");
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_c_date_header = _resolveComponent("c-date-header");
  var _component_bar_echart_mul = _resolveComponent("bar-echart-mul");
  var _component_c_no_data = _resolveComponent("c-no-data");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_c_title, {
    title: "实时考勤",
    showIcon: false
  }), _createVNode(_component_van_grid, {
    class: "grid",
    gutter: 10,
    "column-num": 3
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendanceData, function (item) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: item.material_name,
          onClick: function onClick($event) {
            return _ctx.jumpPage(item.routeName);
          }
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1)];
          }),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))];
    }),
    _: 1
  }), _createVNode(_component_c_title, {
    class: "mt-2",
    title: "本日各部门出勤情况",
    showIcon: false
  }), _createElementVNode("div", _hoisted_5, [_createElementVNode("table", _hoisted_6, [_hoisted_7, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.depAttendanceInfo, function (item) {
    return _openBlock(), _createElementBlock("tr", {
      key: item.dep_name
    }, [_createElementVNode("td", null, _toDisplayString(item.dep_name), 1), _createElementVNode("td", null, _toDisplayString(item.require_count), 1), _createElementVNode("td", null, _toDisplayString(item.absent_count), 1), _createElementVNode("td", null, _toDisplayString(item.attendance), 1)]);
  }), 128))])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_c_date_header, {
    type: 2,
    onConfirmDate: _ctx.confirmDate,
    showLabel: false
  }, null, 8, ["onConfirmDate"])]), _createElementVNode("div", _hoisted_10, [_ctx.mainPro.lineData.flatMap(function (item) {
    return item;
  }).length ? (_openBlock(), _createBlock(_component_bar_echart_mul, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.mainPro)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))])])]);
}